module.exports = __webpack_public_path__ + "static/media/Group 831.dada004c.svg";